// redux/slices/personalLoanSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// API call to submit loan
export const submitLoanApplication = createAsyncThunk(
  'personalLoan/submitLoanApplication',
  async (loanData, { rejectWithValue }) => {
    try {
      const response = await fetch('https://narrowitsolution.in/api/new-apply-loan', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(loanData)
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.message || 'Something went wrong');
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const personalLoanSlice = createSlice({
  name: 'personalLoan',
  initialState: {
    loading: false,
    success: false,
    error: null
  },
  reducers: {
    resetStatus: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitLoanApplication.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(submitLoanApplication.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(submitLoanApplication.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { resetStatus } = personalLoanSlice.actions;
export default personalLoanSlice.reducer;
